import { FeatureToolTipImage } from "@omni/types/api/product/bff/shared/featureToolTipImage.model";
import { CloudFeatureToolTipImage } from "@omni/types/api/product/cloud/shared/featureToolTipImage.model";
import { NullableModelMapper } from "@omni/types/utils/modelMapper";

const fromCloud: NullableModelMapper<
    CloudFeatureToolTipImage,
    FeatureToolTipImage
> = (model) => {
    if (!model) {
        return null;
    }

    return {
        altText: model.altText,
        code: model.code,
        url: model.url,
        mimeType: model.mimeType,
        description: model.description,
        format: model.format
    } satisfies FeatureToolTipImage;
};

export const FeatureTooltipImageMapper = {
    fromCloud
};
